export default __webpack_public_path__ + "static/media/work_blog-category.18562ad9.jpg";